// Node-coloring React context. Mirrors the DiffContext pattern: a host
// (the viewer App, Studio's diff board) builds a `NodeColoring` with an
// adapter and provides it; the board's WidgetNode / TemplateNode and the
// Minimap read it. Null = no active colouring (every node keeps its
// kind-default colour).

import { createContext, useContext } from "react";
import type { NodeColoring } from "./types.js";

export const NodeColoringContext = createContext<NodeColoring | null>(null);

export function useNodeColoring(): NodeColoring | null {
  return useContext(NodeColoringContext);
}
